import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './task.reducer';

export const TaskDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const taskEntity = useAppSelector(state => state.task.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="taskDetailsHeading">
          <Translate contentKey="crawlerBackendApp.task.detail.title">Task</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{taskEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="crawlerBackendApp.task.name">Name</Translate>
            </span>
          </dt>
          <dd>{taskEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.task.description">Description</Translate>
            </span>
          </dt>
          <dd>{taskEntity.description}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="crawlerBackendApp.task.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {taskEntity.startDate ? (
              <TextFormat value={taskEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.task.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {taskEntity.endDate ? (
              <TextFormat value={taskEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="taskStatus">
              <Translate contentKey="crawlerBackendApp.task.taskStatus">Task Status</Translate>
            </span>
          </dt>
          <dd>{taskEntity.taskStatus}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.task.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {taskEntity.createdTimestamp ? (
              <TextFormat value={taskEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.task.workOrder">Work Order</Translate>
          </dt>
          <dd>{taskEntity.workOrder ? taskEntity.workOrder.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.task.owner">Owner</Translate>
          </dt>
          <dd>{taskEntity.owner ? taskEntity.owner.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/task" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/task/${taskEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TaskDetail;
